import { createFileRoute } from '@tanstack/react-router'
import { APP_NAME } from '@/lib/utils'
import LivreursFee from '@/features/livreurs-fee'

export const Route = createFileRoute('/_authenticated/livreurs-fee/')({
  component: LivreursFee,
  head: () => ({
    meta: [
      {
        title: `${APP_NAME} | Frais de livreurs`,
      },
    ],
  }),
})
